import React, { Component } from 'react';
import { Card, Button, Modal } from 'react-bootstrap';
import { getAuth } from 'firebase/auth';
import { CartContext } from '../context/CartContext';

class Catalogues extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      isLoading: false,
      cartStatus: '',
    };
  }

  handleCardClick = () => {
    this.setState({ showModal: true });
  };

  handleClose = () => {
    this.setState({ showModal: false });
  };

 handleAddToCart = async (productId, addToCart) => {
    this.setState({ isLoading: true, cartStatus: '' });
    try {
      await addToCart(productId, 1);
      this.setState({ cartStatus: 'Produit ajouté au panier avec succès.' });
    } catch (error) {
      console.error('Erreur lors de l\'ajout au panier:', error);
      this.setState({ cartStatus: 'Erreur lors de l\'ajout au panier.' });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  render() {
    const { product } = this.props;
    const { showModal, isLoading, cartStatus } = this.state;

    if (!product) {
      return <div>Produit non disponible</div>;
    }

    const baseURL = 'http://localhost:5000/';
    const productImage = product.productImage
      ? `${baseURL}${product.productImage.replace(/\\/g, '/')}`
      : `${baseURL}uploads/default.png`;

    return (
      <CartContext.Consumer>
        {({ addToCart }) => (
          <>
            <Card
              style={{
                border: '1px solid #ccc',
                borderRadius: '8px',
                margin: '20px',
                width: '250px',
                cursor: 'pointer',
              }}
              onClick={this.handleCardClick}
            >
              <Card.Img
                variant="top"
                src={productImage}
                alt={`Image de ${product.name}`}
                onError={(e) => {
                  e.target.src = `${baseURL}uploads/default.png`; // Utilisation d'un fallback
                }}
                style={{ width: '100%', height: '250px', objectFit: 'cover' }}
              />
              <Card.Body>
                <Card.Title>{product.name}</Card.Title>
                <Card.Text>{product.price} DT</Card.Text>
                <Button
                  style={{ backgroundColor: '#C53E3E', color: 'white', border: 'none' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.handleAddToCart(product, addToCart);
                  }}
                  disabled={isLoading}
                >
                  {isLoading ? 'Ajout en cours...' : 'Ajouter au Panier'}
                </Button>
                {cartStatus && <p style={{ color: 'green', marginTop: '10px' }}>{cartStatus}</p>}
              </Card.Body>
            </Card>

            <Modal style={{ borderRadius: '8px' }} show={showModal} onHide={this.handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Détails du produit</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <img
                  src={productImage}
                  alt={product.name}
                  style={{
                    width: '70%',
                    height: '400px',
                    marginBottom: '20px',
                    marginLeft: '50px',
                  }}
                />
                <p>
                  <strong>Nom du produit :</strong> {product.name}
                </p>
                <p>
                  <strong>Description :</strong> {product.description}
                </p>
                <p>
                  <strong>Prix :</strong> {product.price} DT
                </p>
                <p>
                  <strong>Vendeur :</strong> {product.username || 'Nom du vendeur inconnu'}
                </p>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={this.handleClose}
                  style={{ backgroundColor: '#6c757d', border: 'none' }}
                >
                  Fermer
                </Button>
                <Button
                  variant="success"
                  onClick={() => {
                    this.handleAddToCart(product, addToCart);
                    this.handleClose();
                  }}
                  disabled={isLoading}
                  style={{ backgroundColor: '#28a745', border: 'none' }}
                >
                  {isLoading ? 'Ajout en cours...' : 'Ajouter au panier'}
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        )}
      </CartContext.Consumer>
    );
  }
}

export default Catalogues;
